import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';

import Cookies from 'universal-cookie';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Rating } from 'primereact/rating'; // Se mantiene por si se usa en otro contexto, pero lo quitamos del template
import { InputText } from 'primereact/inputtext';

import { environment } from "./util/baseUrl";
import { useNavigate } from 'react-router-dom';

const ListaHistorias = () => {

    const cookies = new Cookies();
    // const isUserLoggedIn = cookies.get('id') ? true : false; // Ya no es necesario

    const navigate = useNavigate();
    
    const historiasBaseUrl = environment.baseUrl + "historias"; 
    const baseImagenUrl = environment.baseUrl + 'imagenes/'; 

    const [dataViewValue, setDataViewValue] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filteredValue, setFilteredValue] = useState(null);
    const [layout, setLayout] = useState('grid');

    const toast = useRef(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [sortField, setSortField] = useState(null);

    const formatDate = (dateString) => {
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', options);
    };

    // 1. FUNCIÓN DE REDIRECCIÓN CLAVE
    const verDetalle = (historiaId) => {
        // Redirecciona a la ruta /historia/{id}
        navigate(`/historia/${historiaId}`);
    };

    const peticionGet = async () => {
        await axios.get(historiasBaseUrl)
            .then(response => {
                setDataViewValue(response.data.content); 
            }).catch(error => {
                console.log("Error al obtener historias:", error);
            })
    }


    useEffect(() => {
        peticionGet()
        document.documentElement.style.fontSize = 14 + 'px';
    }, []);


    const onFilter = (e) => {
        const value = e.target.value;
        setGlobalFilterValue(value);
        if (value.length === 0) {
            setFilteredValue(null);
        } else {
            const filtered = dataViewValue.filter((historia) => {
                return historia.titulo.toLowerCase().includes(value.toLowerCase());
            });
            setFilteredValue(filtered);
        }
    };

    const dataViewHeader = (
        <div className="flex flex-column md:flex-row md:justify-content-between gap-2">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilterValue} onChange={onFilter} placeholder="Buscar por título" />
            </span>
            <DataViewLayoutOptions layout={layout} onChange={(e) => setLayout(e.value)} />
        </div>
    );

    const dataviewListItem = (data) => {
        
        return (
            <div className="col-12">
                <div className="flex flex-column md:flex-row align-items-center p-3 w-full border-1 surface-border border-round">
                    {/* Hacemos la imagen clickeable para navegar */}
                    <img 
                        src={baseImagenUrl + data.urlImagen} 
                        alt={data.titulo} 
                        className="my-4 md:my-0 w-9 md:w-10rem shadow-2 mr-5 cursor-pointer"
                        onClick={() => verDetalle(data.id)} // <--- APLICACIÓN DE LA REDIRECCIÓN
                        style={{ cursor: 'pointer' }}
                        onError={(e) => {
                            e.target.src = "/logos/logoua.png";
                            e.target.style.transform = "scale(0.5)"; 
                            e.target.style.objectFit = "contain"; 
                        }} 
                    />
                    <div className="flex-1 flex flex-column align-items-center text-center md:text-left">
                        <div className="font-bold text-2xl cursor-pointer" onClick={() => verDetalle(data.id)} style={{ cursor: 'pointer' }}>
                            {data.titulo}
                        </div>
                        <div className="mb-2 text-600">{data.autor || data.ponente}</div> 
                        {/* <Rating value="5" readOnly cancel={false} className="mb-2"></Rating> ELIMINADO POR CONTEXTO BLOG */}
                        <div className="flex align-items-center">
                            <i className="pi pi-tag mr-2"></i>
                            <span className="font-semibold">{data.categoria ? data.categoria.titulo : 'General'}</span> 
                        </div>
                    </div>
                    
                    {/* Botón para la acción principal */}
                    <div className="flex align-items-center justify-content-center">
                        <Button
                            label="Ver más"
                            icon="pi pi-angle-right"
                            iconPos="right"
                            className="p-button-secondary p-button-text"
                            onClick={() => verDetalle(data.id)} // <--- APLICACIÓN DE LA REDIRECCIÓN
                        />
                    </div>
                </div>
            </div>
        );
    };

    const dataviewGridItem = (data) => {
        
        return (
            <div className="col-12 lg:col-4">
                <div className="card m-3 border-1 surface-border h-full flex flex-column">

                    <div className="flex flex-wrap gap-2 align-items-center justify-content-between mb-2">
                        <div className="flex align-items-center">
                            <i className="pi pi-tag mr-2" />
                            <span className="font-semibold">{data.categoria ? data.categoria.titulo : 'General'}</span>
                        </div>
                        <div className="flex align-items-center text-sm">
                            <i className="pi pi-calendar mr-2" />
                            <span className="font-medium">{formatDate(data.fechaPublicacion)}</span> 
                        </div>
                    </div>

                    <div className="flex flex-column align-items-center text-center mb-3 flex-1">
                        {/* Hacemos la imagen clickeable para navegar */}
                        <img 
                            src={baseImagenUrl + data.urlImagen} 
                            alt={data.titulo} 
                            className="w-5 shadow-2 my-3 mx-0 cursor-pointer"
                            onClick={() => verDetalle(data.id)} // <--- APLICACIÓN DE LA REDIRECCIÓN
                            style={{ cursor: 'pointer' }}
                            onError={(e) => {
                                e.target.src = "/logos/logoua.png";
                                e.target.style.transform = "scale(0.5)";
                                e.target.style.objectFit = "contain";
                            }} 
                        />
                        <div className="text-2xl font-bold cursor-pointer" onClick={() => verDetalle(data.id)} style={{ cursor: 'pointer' }}>
                            {data.titulo}
                        </div>
                        <div className="mb-3">{data.autor || data.ponente}</div>
                        {/* <Rating value="5" readOnly cancel={false} /> ELIMINADO POR CONTEXTO BLOG */}
                    </div>

                    {/* Botón para la acción principal */}
                    <div className="mt-auto flex align-items-center justify-content-center">
                        <Button
                            label="Ver más"
                            icon="pi pi-angle-right"
                            iconPos="right"
                            className="p-button-secondary p-button-text"
                            onClick={() => verDetalle(data.id)} // <--- APLICACIÓN DE LA REDIRECCIÓN
                        />
                    </div>
                </div>
            </div>
        );
    };

    const itemTemplate = (data, layout) => {
        if (!data) {
            return;
        }

        if (layout === 'list') {
            return dataviewListItem(data);
        } else if (layout === 'grid') {
            return dataviewGridItem(data);
        }
    };

    return (
        <div className="grid list-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Button title="Volver" icon="pi pi-arrow-left" className="p-button-rounded p-button-outlined p-button mr-2" onClick={() => { navigate(`/index`); }} />
                    <br />
                    <DataView value={filteredValue || dataViewValue} layout={layout} paginator rows={9} sortOrder={sortOrder} sortField={sortField} itemTemplate={itemTemplate} header={dataViewHeader}></DataView>
                </div>
            </div>
        </div>
    );
};

export default ListaHistorias;